import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import { Alert, Box, Button, Container, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import PageTitle from "components/PageTitle";
import { FormTextField } from "components/FormInputs";

export default function NoteItemAddPage() {

  const navigate = useNavigate();
  const { noteId } = useParams();

  const [isInvalidAmount, setIsInvalidAmount] = useState(false);
  const [isAddSuccessed, setIsAddSuccessed] = useState(false);

  const schema = yup.object().shape({
    type: yup.string().required("증가/차감 여부를 선택해주세요."),
    amount: yup.number().required("금액을 입력해주세요."),
    detail: yup.string().required("상세를 입력해주세요.")
  });

  const {
    control,
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const addNoteItem = (formData) => {
    if (formData.amount <= 0) {
      setIsInvalidAmount(true);
      return;
    }

    setIsInvalidAmount(false);
    formData.noteId = noteId;

    axios.post("/api/note/item/add", formData)
    .then(res => {
      setIsAddSuccessed(true)
    })
    .catch(err => {
      alert("등록에 실패하였습니다.");
    });
  }

  return (
    <Container>
      <PageTitle>✏️&nbsp;항목 추가</PageTitle>

      {!isAddSuccessed ?
        <form onSubmit={handleSubmit(addNoteItem)}>
          <Grid container flexDirection="column" gap="16px">
            {isInvalidAmount &&
              <Alert severity="error" onClose={() => setIsInvalidAmount(false)}>금액은 0보다 커야 합니다.</Alert>
            }
            <RadioGroup sx={{flexDirection: "row"}}>
              <FormControlLabel
                name="type"
                {...register("type")}
                value="I"
                label="증가"
                control={<Radio/>}
              />
              <FormControlLabel
                name="type"
                {...register("type")}
                value="D"
                label="차감"
                control={<Radio/>}
              />
            </RadioGroup>

            <FormTextField
              name="amount"
              control={control}
              label="금액"
              error={errors.amount}
              type="number"
            />

            <FormTextField
              name="detail"
              label="상세"
              control={control}
              minRows={5} 
              multiline
              error={errors.detail}
            />

            <Grid item>
              <Grid container gap="8px">
                <Button variant="outlined" sx={{flex: 1}} onClick={() => navigate(-1)}>취소</Button>
                <Button variant="contained" sx={{flex: 1}} type="submit">등록</Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
        :
        <Grid container flexDirection="column" alignItems="center" sx={{color: "gray"}}>
          <CheckIcon sx={{fontSize: "3rem", marginBottom: "4px"}}/>
          <Typography fontSize={"1.25rem"} marginBottom="32px">항목이 생성되었습니다.</Typography>

          <Box sx={{display: "flex", gap: "8px"}}>
            <Button variant="outlined" onClick={() => navigate("/")}>홈으로</Button>
            <Button variant="outlined" onClick={() => navigate(`/note/${noteId}`)}>노트로 이동</Button>
          </Box>
        </Grid>
      }
    </Container>
  );
}